import {Card} from 'primereact/card';
import {Divider} from 'primereact/divider';
import * as Icon from '../assets/icons';
import {useAppSelector, useTranslation} from '../hooks';
import {themeState} from '../redux/slices/app';
import {Colors} from '../utils';

const Features = () => {
  const {t} = useTranslation();
  const selectedTheme = useAppSelector(themeState);

  return (
    <section
      style={{backgroundColor: 'var(--primary-color)'}}
      className="flex flex-wrap justify-content-center align-items-center gap-4 p-6"
      id="features">
      <Card className="w-full md:w-3 text-center shadow-md rounded-lg p-5 border border-gray-200 surface-card align-items-center">
        <Icon.CncMachine
          size={70}
          title={t('iconCncMachine')}
          color={selectedTheme === 'light' ? Colors.primary700 : Colors.white}
        />
        <Divider />
        <figcaption
          className={`text-lg font-semibold ${
            selectedTheme === 'light' ? 'text-primary-700' : 'text-white'
          }`}>
          {t('featuresCncTitle')}
        </figcaption>
      </Card>

      <Card className="w-full md:w-3 text-center shadow-md rounded-lg p-5 border border-gray-200 surface-card align-items-center">
        <Icon.Professional
          size={70}
          title={t('iconProfessional')}
          color={selectedTheme === 'light' ? Colors.primary700 : Colors.white}
        />
        <Divider />
        <figcaption
          className={`text-lg font-semibold ${
            selectedTheme === 'light' ? 'text-primary-700' : 'text-white'
          }`}>
          {t('featuresProfessionalTitle')}
        </figcaption>
      </Card>

      <Card className="w-full md:w-3 text-center shadow-md rounded-lg p-5 border border-gray-200 surface-card align-items-center">
        <Icon.Quality
          size={70}
          title={t('iconQuality')}
          color={selectedTheme === 'light' ? Colors.primary700 : Colors.white}
        />
        <Divider />
        <figcaption
          className={`text-lg font-semibold ${
            selectedTheme === 'light' ? 'text-primary-700' : 'text-white'
          }`}>
          {t('featuresQualityTitle')}
        </figcaption>
      </Card>

      <Card className="w-full md:w-3 text-center shadow-md rounded-lg p-5 border border-gray-200 surface-card align-items-center">
        <Icon.Delivery
          size={70}
          title={t('iconDelivery')}
          color={selectedTheme === 'light' ? Colors.primary700 : Colors.white}
        />
        <Divider />
        <figcaption
          className={`text-lg font-semibold ${
            selectedTheme === 'light' ? 'text-primary-700' : 'text-white'
          }`}>
          {t('featuresDeliveryTitle')}
        </figcaption>
      </Card>
    </section>
  );
};

export default Features;
